const INVOICES_TABLE = {
  HEADERS: {
    CLIENT_COMPANY_NAME: 'Cliente',
    CLIENT_RUT: 'Rut cliente',
    DEBTOR_COMPANY_NAME: 'Deudor',
    DEBTOR_RUT: 'Rut deudor',
    DEBTOR_COMPANY_RANKING: 'Tramo deudor',
    RECEPTION_DATE: 'Fecha recepción',
    TOTAL_AMOUNT: 'Monto total',
    FOLIO: 'Folio',
    DOCUMENT_TYPE: 'Tipo documento',
    ACKNOWLEDGMENT_DATE: 'Acuso recibo',
    CLAIM_DATE: 'Fecha reclamo',
    ASSIGNEE_COMPANY_NAME: 'Factoring',
    ASSIGNEE_RUT: 'Rut factoring',
    ASSIGNMENT_DATE: 'Fecha cesión',
    STATUS: 'Estado',
    AMOUNT: 'Monto',
    CREDIT_NOTE_AMOUNT: 'Monto NC',
  },
};

export { INVOICES_TABLE };
